import dom from "../../../../../../common/ts/core/dom";
import retentionFormActions from './actions';
import localStorage from "../../../../../../common/ts/core/localStorage";
const EMAIL_RETENTION_FORM_SELECTOR = "#js-email-retention-form";
const EMAIL_RETENTION_FORM_SIMPLIFIED_SELECTOR = "#js-email-retention-form--simplified";
const EMAIL_RETENTION_FORM_TOGGLE_SELECTOR = "#toggle-accept-news";
const EMAIL_RETENTION_FORM_SIMPLIFIED_TOGGLE_SELECTOR = "#toggle-accept-news--simplified";

function init(
    emailRetentionToggleTrackingName: string,
    emailRetentionSubmitTrackingName: string,
    pageNumber: number,
    isPaid: boolean,
    isDesktop: boolean,
    actions = retentionFormActions,
) {
   actions.init();
   const formsIds = [EMAIL_RETENTION_FORM_SELECTOR, EMAIL_RETENTION_FORM_SIMPLIFIED_SELECTOR];
   const toogleIds = [EMAIL_RETENTION_FORM_TOGGLE_SELECTOR, EMAIL_RETENTION_FORM_SIMPLIFIED_TOGGLE_SELECTOR];

   formsIds.forEach(formId => actions.initializeRetentionForm(formId, localStorage.getItem("email")))

   toogleIds.forEach(toggleId => {
      const toggleButton = dom.select(toggleId);
      toggleButton?.addEventListener("change", (changeEvent: Event) => {
         const eventTarget = changeEvent.currentTarget as HTMLInputElement;

         actions.changeRetentionToggle(eventTarget, emailRetentionToggleTrackingName);
      });
   });

   formsIds.forEach(formId => {
      const formElement = dom.select(formId) as HTMLFormElement;
      formElement?.addEventListener("submit", (event) => {
         event.preventDefault();
         const formData = new FormData(formElement);
         const openedFrom = formElement.dataset.formOriginOpenedFrom;

         actions.submitRetentionForm(
             formData,
             emailRetentionSubmitTrackingName,
             pageNumber,
             isPaid,
             openedFrom ? openedFrom : "",
             isDesktop,
         )
      });
   });
}

export default {
   init,
}
